import { UserInput } from '../shared/UserInput';
import { UserEditor } from './UserEditor';
import { getUserId, UserType } from './UserType';
import { Section } from '../shared';

import { useSearchParamState } from '../hooks/useSearchParamState';

import styles from './AccountManagement.module.scss';

export const AccountManagement = () => {
    const [user, setUser] = useSearchParamState<UserType | null>(null, 'user');

    return (
        <Section className={styles.container}>
            <menu className={styles.navigation}>
                <UserInput
                    onUserSelected={(user) => setUser(user)}
                    defaultValue={user ?? undefined}
                />
            </menu>

            {user && <UserEditor key={getUserId(user)} user={user} />}
        </Section>
    );
};
